const naoNegativo = value => Math.max(0, Number(value) || 0);

export function calcularValoresItens(itens = [], valorLiquido) {
  let subtotalCentavos = 0;
  let somaLinhasCentavos = 0;

  const linhas = itens.map(item => {
    const quantidade = naoNegativo(item.quantidade);
    const valorUnitario = naoNegativo(item.valorUnitario);
    const percentualDesconto = Math.min(100, naoNegativo(item.percentualDesconto));
    const brutoCentavos = Math.round(valorUnitario * 100) * quantidade;
    const comDescontoCentavos = Math.round(brutoCentavos * (1 - percentualDesconto / 100));

    subtotalCentavos += brutoCentavos;
    somaLinhasCentavos += comDescontoCentavos;

    return {
      descricao: item.descricao,
      quantidade,
      valorUnitario,
      percentualDesconto,
      valorComDesconto: comDescontoCentavos / 100,
    };
  });

  const finalCentavos = naoNegativo(valorLiquido) > 0 ? Math.round(valorLiquido * 100) : somaLinhasCentavos;

  return {
    itens: linhas,
    subtotal: subtotalCentavos / 100,
    desconto: Math.max(0, subtotalCentavos - finalCentavos) / 100,
    valorFinal: finalCentavos / 100,
  };
}
